import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'
import { i18n } from '@/i18n'

export default [
  {
    name: 'tasks',
    path: '/tasks',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "tasks" */ '@/views/Task/Tasks.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'complaints',
    path: '/complaints',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "complaints-tasks" */ '@/views/Task/Tasks.vue')),
    meta: {
      title: ['complaint', 2],
      type: 'complaint',
      context: 'tasks',
      defaultFilter: ctx => ({ search: '', type: 'complaint', status: ['undone', 'request'] }),
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'task-external',
    path: '/task/:id/external',
    props: route => ({
      id: route.params.id,
      token: route.query.token,
    }),
    component: () => LazyLoadView(import(/* webpackChunkName: "task-external" */ '@/views/Task/External.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
]
